import { render } from "./RightBar.vue?vue&type=template&id=3564f148&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=3564f148&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3564f148"]])

export default __exports__